/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudWiseUsageRequest {
    getFixupPrototypeFunction() { return CloudWiseUsageRequest.fixupPrototype; }

    static newInstance(model: Partial<CloudWiseUsageRequest>): CloudWiseUsageRequest {
        let obj = Object.assign(new CloudWiseUsageRequest(), model);
        CloudWiseUsageRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudWiseUsageRequest>): CloudWiseUsageRequest {
        if (!model) return null;
        return CloudWiseUsageRequest.newInstance(<CloudWiseUsageRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudWiseUsageRequest) {
        if (!obj) return;

        models.CloudWiseUsageRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudWiseUsageRequest): boolean {
        Object.setPrototypeOf(obj, CloudWiseUsageRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID for the request
     */
    tenant_id: string;

    service_account_ids: Array<string>;

    /**
     * The field by which the usage data is grouped.
     */
    group_by: models.CloudWiseUsageGroupBy;

    /**
     * Flag to indicate if the cost includes markup
     */
    is_markup: boolean;

    /**
     * The Range of time for which the usage data is requested.
     */
    time_range: models.CloudWiseUsageTimeRange;

    /**
     * Flag to indicate if the cost is projected
     */
    include_forecast_cost: boolean;

}
